// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.theme--dark .v-data-table[data-v-178be4fe],\n.theme--dark .v-expansion-panel[data-v-178be4fe],\n.theme--dark .v-card[data-v-178be4fe] {\n  background: var(--v-background-darken3) !important;\n}\n.theme--dark .v-window-item[data-v-178be4fe] {\n  min-height: 70vh;\n  margin-bottom: 120px !important;\n}\n.v-dialog > .v-card > .v-card__actions[data-v-178be4fe] {\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
